export default "__VITE_ASSET__BnCdx43S__"